import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap-5';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

import { hideEmailModal } from 'bundles/project/actions/index';

export class EmailModal extends React.Component {
  static propTypes = {
    emails: PropTypes.array,
    project: PropTypes.shape({
      forwardingEmail: PropTypes.string.isRequired,
      leaseListingUrl: PropTypes.string,
      saleListingUrl: PropTypes.string
    }).isRequired,
    projectTasksActivities: PropTypes.bool.isRequired,
    onHideEmailModal: PropTypes.func.isRequired
  }

  state = {
    copiedEmails: false
  }

  emails = () => {
    const { emails } = this.props;
    return (emails || []).length > 0 ? emails.join(', ') : 'No emails selected';
  }

  handleCopy = () => {
    this.setState({ copiedEmails: true });
    navigator.clipboard.writeText(this.emails());
    setTimeout(() => {
      this.setState({ copiedEmails: false });
    }, 2000);
  }

  useForwardingEmail = () => {
    const { project, projectTasksActivities } = this.props;

    if (projectTasksActivities)
      return encodeURIComponent(project.forwardingEmail);
    return '';
  }

  mailtoLink = () => {
    const { project, emails } = this.props;
    if (emails == null) return;

    let url = '';

    if (emails.length === 1) {
      url = `${emails[0]}?bcc=${this.useForwardingEmail()}`;
    } else {
      url = `?bcc=${this.emails()}, ${this.useForwardingEmail()}`;
    }

    const links = [];
    if (project.saleListingUrl) links.push(`View Sale Listing: ${project.saleListingUrl}`);
    if (project.leaseListingUrl) links.push(`View Lease Listing: ${project.leaseListingUrl}`);

    return `mailto:${url}&body=${encodeURIComponent(links.join('\n'))}`;
  }

  render() {
    const { emails, onHideEmailModal } = this.props;
    const disableButtons = (emails || []).length < 1;

    return (
      <Modal show={emails != null} onHide={onHideEmailModal} onShow={this.handleShow}>
        <Modal.Header closeButton>
          <Modal.Title>Email Selected Addresses</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{this.emails()}</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-ghost" onClick={onHideEmailModal}>Cancel</button>
          <button className="btn btn-secondary" disabled={disableButtons} name="copyEmails" onClick={this.handleCopy}>
            {this.state.copiedEmails ? (
              <React.Fragment>
                <FontAwesomeIcon className="right-buffer-sm" icon={faCheck} />Copied
              </React.Fragment>
            ) : (
              'Copy'
            )}
          </button>
          <a
            className="btn btn-primary"
            disabled={disableButtons}
            href={disableButtons ? null : this.mailtoLink()}
            name="sendEmail"
            rel="noopener noreferrer"
            target="_blank"
          >
            Send Email
          </a>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = ({ emailModal, project }) => ({ project, emails: emailModal.emails });

export default connect(mapStateToProps, { onHideEmailModal: hideEmailModal })(EmailModal);
